/** Превращает путь до поля в строку */
export function stringifyFieldIdPath(fieldIdPath: string[]) {
    return fieldIdPath.join('.');
}
